// VideoCarousel.jsx
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Flower from "../../assets/pages/flower_design.png"
import { Usb } from 'react-bootstrap-icons';
import './carousel.css'; // Custom CSS for styling
import { isMobile } from 'react-device-detect';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';


const SmallCarousel = ({ achievementData }) => {  
  const sliderRef = useRef(null);
  const settings = {
    dotsClass: "slick-dots",
    infinite: isMobile ? true : false,
    speed: 500,
    autoplay: true,           // Enable autoplay
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    draggable: achievementData?.length > 4,
    swipe:  achievementData?.length > 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 768, // This is the breakpoint for mobile devices
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ],
  };
  
  const handleCardClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };
  
  return (
    <>
      {achievementData?.length > 0 && <div className='relative'>
        <button
          onClick={() => sliderRef.current?.slickPrev()}
          className="absolute left-0 top-1/2 ml-3 transform -translate-y-1/2 z-[2] p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
        >
          <ChevronLeftIcon className="w-6 h-6 text-gray-700" />
        </button>
        <div>
          <Slider ref={sliderRef} {...settings} className='w-full m-auto px-2 max-sm:px-6'>
            {achievementData?.map((card, index) => (
              <div key={index} onClick={() => handleCardClick(index)}>
                <div className='relative'>
                  <img src={Flower} className='mx-auto w-[80%]' alt={"flower"} />
                  <span className='absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 max-sm:text-[12px] text-[12px] bg-[#fff] text-[#000]'>{ card.year }</span>
                </div>  
                <p className='mx-auto w-[80%] mt-2 text-[#222] text-center text-[12px]'>{card.title}</p>
              </div>
            ))}
          </Slider>
        </div>
        <button
          onClick={() => sliderRef.current?.slickNext()}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 z-[2] p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
        >
          <ChevronRightIcon className="w-6 h-6 text-gray-700" />
        </button>
      </div>}
    </>
  );
};

export default SmallCarousel;